import styled from '@emotion/styled/macro';

export const StepperWrapper = styled.nav``;

export const StepperList = styled.ol`
  display: flex;
  margin: 0;
  padding: 0;
`;
